import { Identifier } from 'modules/global/adapters/crpAPI';

export function getIdentifierValue(identifier: Identifier): string {
  switch (identifier) {
    case Identifier.NxtEntityId:
      return Identifier.NxtEntityId;
    case Identifier.VatNumber:
      return 'Tin';
    case Identifier.Duns:
      return Identifier.Duns;
    case Identifier.Eori:
      return Identifier.Eori;
    case Identifier.ApcsCode:
      return 'Apcs';
    default:
      throw new Error('Unknown Identifier');
  }
}
